import React, { Component } from 'react';
import ReactTooltip         from 'react-tooltip';
import { connect }          from 'react-redux';

class BtLikeNave extends Component {
    render() {
    
        const vetor    = this.props.vetor;
        const likes    = this.props.all_posts_nave[vetor].num_like;
        const pos_id   = this.props.all_posts_nave[vetor].tur_pos_id;
       
        return (

            <a
                href={void(0)}
                data-tip data-for={'like_'}
                onClick={this.props.funcao}
                id={`like_${pos_id}`}
                className="action action-icon action-simple action-labeled">
                <i className="gamefica-icon gamefica-heart" id={`icon_like_${pos_id}`}></i>
                <span>+{likes === 0 ? 0 : likes}</span>
                <ReactTooltip
                    id={'like_'}
                    type='dark'
                    effect='solid'>
                    <span>Like</span>
                </ReactTooltip>
            </a>
                   
        );
    }
}

function  mapStateToProps(state){

    return { all_posts_nave : state.turmaReducer.all_posts}
}

export default connect(mapStateToProps)(BtLikeNave);



// WEBPACK FOOTER //
// ./src/container/bt_like_hud.js